import { OverlayRef } from '@angular/cdk/overlay';

import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { Subject, takeUntil } from 'rxjs';
import { FuseAlertModule } from '../../../../@fuse/components/alert/alert.module';
import { FuseDrawerModule } from '../../../../@fuse/components/drawer/drawer.module';
import { PipesModule } from '../../../core/pipes/pipes.module';
import { FuseDrawerComponent } from '../../../../@fuse/components/drawer/drawer.component';
import { ClipboardService } from '../../../core/clipboard/clipboard.service';
import { DialogsService } from '../../../dialogs/dialogs.service';
import { Clipboard } from '../../../core/clipboard/clipboard.model';

@Component({
    selector: 'clipboard',
    templateUrl: './clipboard.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [
    RouterModule,
    MatIconModule,
    FuseAlertModule,
    FuseDrawerModule,
    MatBadgeModule,
    MatButtonModule,
    MatTooltipModule,
    PipesModule,
    TranslocoModule
],
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class ClipboardComponent implements OnInit, OnDestroy {

    @ViewChild('clipDrawer') drawer: FuseDrawerComponent;

    clipboard: Clipboard[] = [];

    readonly fieldTypes = ['formField', 'masterField', 'tasktypeField'];

    private _unsubscribeAll: Subject<void> = new Subject<void>();

    constructor(
        private clipboardService: ClipboardService,
        private dialogsService: DialogsService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.clipboardService.clipboard$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((clipboard) => {
                this.clipboard = clipboard;
                if (this.clipboard.length === 0) {
                    this.drawer?.close();
                }
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    clearClipboard() {
        this.clipboardService.clearClipboard();
        this.drawer.close();
    }

    discardItem(index: number) {
        this.clipboardService.discardItem(index);
    }

    getBadgeText(): number | string {
        return this.clipboard.length > 9 ? '9+' : this.clipboard.length;
    }

    showData(clipboardItem: Clipboard) {
        this.dialogsService.openClipboardDataDialog(clipboardItem);
    }

    canPaste(clipboardItem: Clipboard) {
        return clipboardItem.type === 'formField' && this.router.url.includes('form/design')
            || clipboardItem.type === 'masterField' && this.router.url.includes('master/design')
            || clipboardItem.type === 'tasktypeField' && this.router.url.includes('/tasktype/');
    }

    paste(clipboardItem: Clipboard) {
        this.clipboardService.pasteItem(clipboardItem);
        this.drawer?.close();
    }
}
